var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx } from "react/jsx-runtime";
import { Component, isValidElement } from "react";
import { PAGE_FUNCTION, PAGE_NAME, PAGE_SUBFUNCTION, } from "../../const/analytics";
import ErrorFallback from "./ErrorFallback";
import MainContext from "../Context";
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            hasError: false,
            error: null,
        };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        return { hasError: true, error: error };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState({ error: error });
        console.error("Uncaught error:", error, errorInfo);
    };
    ErrorBoundary.prototype.render = function () {
        var _a = this.state, hasError = _a.hasError, error = _a.error;
        var _b = this.props, children = _b.children, customFallback = _b.customFallback;
        var triggerAnalyticsEvent = this.context.triggerAnalyticsEvent;
        if (hasError && error) {
            // create analytics request when an error happen
            if (triggerAnalyticsEvent) {
                triggerAnalyticsEvent({
                    pageFunction: PAGE_FUNCTION,
                    pageSubFunction: PAGE_SUBFUNCTION,
                    pageName: PAGE_NAME.ERROR,
                });
            }
            // so we don't mess up trying to render an unrenderable custom fallback
            var shouldShowCustomFallback = isValidElement(customFallback);
            return shouldShowCustomFallback ? (customFallback) : (_jsx(ErrorFallback, { error: error }));
        }
        return children;
    };
    // eslint-disable-next-line
    ErrorBoundary.contextType = MainContext;
    return ErrorBoundary;
}(Component));
export default ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.js.map